<app-header [condensed]="condensed" (toggleCondensed)="onToggleCondensed()"></app-header>
<div class="main-container-div">
  <app-side-navigation [(condensed)]="condensed"></app-side-navigation>
  <div class="content-container">
    @if (showBreadcrumbs && !isInFullscreen()) {
      <app-breadcrumbs></app-breadcrumbs>
    }
    <div class="main-panel"
      [ngClass]="{ 'default': !isInFullscreen(), 'fullscreen': isInFullscreen() }">
      <fd-layout-panel style="overflow:auto;">
        <fd-layout-panel-body class="fd-layout-panel-body">
          @if (isInFullscreen()) {
            <div>
              <div class="relations-container">
                <div #relationsComponent></div>
              </div>
            </div>
          }
          <main style="position: relative;">
            <router-outlet class="inner-router" #outlet="outlet"></router-outlet>
          </main>
        </fd-layout-panel-body>
      </fd-layout-panel>
    </div>
  </div>
  @if (Utils.isAiAssistantAvailable() && (aiAssistantService.isOpen$ | async)) {
    <div class="ai-chat-panel-dock">
      <app-ai-chat-panel></app-ai-chat-panel>
    </div>
  }
</div>


